var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Cadastro CAR:",
                  content: _vm.dadosJson.imovel.numeroReciboCar || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Denominação:",
                  content: _vm.dadosJson.imovel.denominacao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Número da Matrícula:",
                  content: _vm.dadosJson.imovel.numeroMatricula || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Averbação de Transferência de Domínio:",
                  content:
                    _vm.dadosJson.imovel.averbacaoTransferenciaDominio || "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Averbação Georreferenciamento:",
                  content:
                    _vm.dadosJson.imovel.averbacaoGeorreferenciamento || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "CNS da Matrícula:",
                  content: _vm.dadosJson.imovel.cnsMatricula || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "SNCR:",
                  content: _vm.dadosJson.imovel.sncr || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "NIRF:",
                  content: _vm.dadosJson.imovel.nirf || "-"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.dadosJson.georreferenciamento.localizacoes &&
      _vm.dadosJson.georreferenciamento.localizacoes.length
        ? _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "pad" },
              [
                _c("app-resumo-mapa", {
                  attrs: {
                    idMapa: "id-mapa-localizacao-rf",
                    height: 30,
                    localizacoes: _vm.dadosJson.georreferenciamento.localizacoes.map(
                      function(l) {
                        return l.geometry
                      }
                    ),
                    isVisualizarCadastro: true
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.dadosJson.imovel.documentos
        ? _c("listagem-documentos", {
            attrs: {
              documentos: _vm.dadosJson.imovel.documentos,
              protocoloCadastroOriginal: _vm.dadosJson.protocolo,
              ownerDocumento: "IMOVEL",
              compararDocumentos: null,
              versaoCadastro: null
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e7d7bfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7d7bfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/ImovelRf.vue
// module id = null
// module chunks = 